<template>
  <div class="packageInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      包裝資訊
    </li>
    <b-table
      :items="packageInformationItem"
      :fields="packageInformationFields"
      class="text-center packageInformation-table-detail"
    >
      <template #head(item_title)="">
        <div class="packageInformation-table-line">
          <span class="packageInformation-table-item">項目</span>
          <span class="packageInformation-table-status">狀態</span>
        </div>
      </template>
      <template #head(item_title_2)="">
        <div class="packageInformation-table-line">
          <span class="packageInformation-table-item">項目</span>
          <span class="packageInformation-table-status">狀態</span>
        </div>
      </template>
      <template #cell(item_title)="{ item }">
        <template v-if="item.item_title.length == 1">
          {{ item.item_title[0] }}
        </template>
        <template v-else-if="item.item_title.length == 2">
          <div>{{ item.item_title[0] }}</div>
          <div>{{ item.item_title[1] }}</div>
        </template>
      </template>
      <template #cell(qty)="{ item }">
        <template v-if="item.qty.length == 1">
          {{ item.qty[0].toLocaleString("en-US") }}
        </template>
        <template v-else-if="item.qty.length == 2">
          <div>{{ item.qty[0].toLocaleString("en-US") }}</div>
          <div>{{ item.qty[1].toLocaleString("en-US") }}</div>
        </template>
      </template>
      <template #cell(total_weight)="{ item }">
        <template v-if="item.total_weight.length == 1">
          {{ item.total_weight[0].toLocaleString("en-US") }}
        </template>
        <template v-else-if="item.total_weight.length == 2">
          <div>{{ item.total_weight[0].toLocaleString("en-US") }}</div>
          <div>{{ item.total_weight[1].toLocaleString("en-US") }}</div>
        </template>
      </template>
      <template #cell(package_qty)="data">
        <div style="position: relative; width: 100%; height: 100%">
          <div
            v-if="data.index == 1"
            style="position: absolute; top: -12px; width: 100%"
          >
            <div class="text-center">
              {{ data.value.toLocaleString("en-US") }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(package_box_qty)="data">
        <div style="position: relative; width: 100%; height: 100%">
          <div
            v-if="data.index == 1"
            style="position: absolute; top: -12px; width: 100%"
          >
            <div class="text-center">
              {{ data.value }}
            </div>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "packageInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      packageInformationFields:
        "packageInformation/get_packageInformationFields",
      packageInformationItem: "packageInformation/get_packageInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.packageInformation-table-line {
  border-top: 2.8rem #cccccc solid; /*上邊框寬度等於表格第一行行高*/
  width: 0px; /*讓容器寬度為0*/
  height: 0px; /*讓容器高度為0*/
  border-left: 5rem #bdbdbd solid; /*左邊框寬度等於表格第一行第一格寬度*/
  position: relative; /*讓裡面的兩個子容器絕對定位*/
  color: #000000;
}
.packageInformation-table-item {
  font-style: normal;
  display: block;
  position: absolute;
  top: -43px;
  left: -40px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}
.packageInformation-table-status {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  left: -85px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}

.packageInformation-table-detail thead th {
  border-top: 1px solid;
}
.packageInformation-table-detail th,
.packageInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.packageInformation-table-detail th:first-child,
.packageInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.packageInformation-table-detail {
  margin-bottom: 0px;
}
.packageInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.packageInformation-table-detail thead tr:last-child th:nth-child(1) {
  width: 5rem;
  min-width: 5rem;
}
.packageInformation-table-detail > tbody > tr > td:nth-child(1) {
  padding: 0;
}
.packageInformation-table-detail > tbody > tr > td:nth-child(1) > div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
}
.packageInformation-table-detail
  > tbody
  > tr
  > td:nth-child(1)
  > div:nth-child(1) {
  border-bottom: 1px solid #999999;
}

.packageInformation-table-detail > tbody > tr > td:nth-child(2) {
  padding: 0;
}
.packageInformation-table-detail > tbody > tr > td:nth-child(2) > div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
}
.packageInformation-table-detail
  > tbody
  > tr
  > td:nth-child(2)
  > div:nth-child(1) {
  border-bottom: 1px solid #999999;
}

.packageInformation-table-detail > tbody > tr > td:nth-child(3) {
  padding: 0;
}
.packageInformation-table-detail > tbody > tr > td:nth-child(3) > div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
}
.packageInformation-table-detail
  > tbody
  > tr
  > td:nth-child(3)
  > div:nth-child(1) {
  border-bottom: 1px solid #999999;
}

.packageInformation-table-detail thead tr:last-child th:nth-child(3) {
  border-right: 5px solid #666666 !important;
}
.packageInformation-table-detail tbody tr td:nth-child(3) {
  border-right: 5px solid #666666 !important;
}

.packageInformation-table-detail thead tr:last-child th:nth-child(4) {
  width: 5rem;
  min-width: 5rem;
}
.packageInformation-table-detail tr td:nth-child(1),
.packageInformation-table-detail tr td:nth-child(4) {
  background-color: #bdbdbd;
}

.packageInformation-table-detail tbody tr:nth-child(2) td:nth-child(9) {
  border-top: none !important;
}
.packageInformation-table-detail tbody tr:nth-child(1) td:nth-child(9) {
  border-bottom: none !important;
}

.packageInformation-table-detail tbody tr:nth-child(2) td:nth-child(10) {
  border-top: none !important;
}
.packageInformation-table-detail tbody tr:nth-child(1) td:nth-child(10) {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/packageInformation.vue